<template>
  <base-section id="products" style="padding: 50px 0px;">
    <div class="text-center" v-if="$route.name === 'produk'">
    <v-chip
      v-for="data in filter"
      :key="data.flag"
      :class="data.flag === select ?'ma-2 primary':'ma-2 '"
      @click="select = data.flag"
      label
    >
      <v-icon left color="white">{{ data.icon }}</v-icon>
      {{ data.id }}
    </v-chip>
    </div>
    <div 
    data-aos="fade-up"
    data-aos-delay="50"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-mirror="true"
    data-aos-once="true"
    data-aos-anchor-placement="top-center"
    v-if="$route.name === 'beranda' || $route.name ===''">
    <base-section-heading title="Selamat Datang" class="text-uppercase">
     <span class="text-capitalize">PT Asuransi Takaful Umum merupakan pionir dalam perusahaan asuransi umum syariah yang telah melayani masyarakat Indonesia sejak 1995</span>
    </base-section-heading>
    </div>
    <div 
    data-aos="fade-right"
    data-aos-delay="50"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-mirror="true"
    data-aos-once="true"
    data-aos-anchor-placement="top-center">
    <v-container>
      <template>
        <v-row>
        <v-col
          v-for="(data, i) in filtered"
          :key="i"
          cols="12"
          xs="12"
          md="4"
          sm="6"
          class="pa-1"
          @click="Detail(data.web_product_id,data.web_product_specialf)"
        >
        <v-card
          class="mx-auto cursor"
          max-width="400"
          height="200px"
        >
          <v-img
            class="white--text align-end"
            height="200px"
            :src="data.web_product_src_url"
            gradient="to right, rgba(0, 31, 72, 0.7), rgba(0, 0, 0, 0)"
            :alt="data.web_product_name"
          >
            <v-card-title
              class="product-card-title"
              v-text="data.web_product_name"
            ></v-card-title>
          </v-img>
          <v-card-text>
          </v-card-text>
        </v-card>
        </v-col>
        <v-col class="text-center">
        <base-btn
          :block="$vuetify.breakpoint.smAndDown"
          color="accent"
          large
          outlined
          @click = "GoTo"
          v-if="$route.name === 'beranda' || $route.name === 'produk-detail' || $route.name ===''"
          class = "text-capitalize"
        >
          Lihat Produk Lainnya
        </base-btn>
      </v-col>
      </v-row>
      </template>
    </v-container>
    <v-snackbar
        v-model="snackbar.value"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
        <v-btn
          color="fourth"
          text
          v-bind="attrs"
          @click="snackbar.value = false"
        >
          Close
        </v-btn>
      </template>
      </v-snackbar>
    </div>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionProducts',
    data: () => ({
      select: 'N',
      filter: [
      // { id: 'Semua', flag: 'semua', icon: 'mdi-check' },
      { id: 'Produk', flag: 'N', icon: 'mdi-label' },
      { id: 'Unggulan', flag: 'Y', icon: 'mdi-fire' },
      ],
      posts: [],
      snackbar: {
        value: false,
        text: ''
      }
    }),
    computed: {
      filtered () {
        const self = this;
        if (self.select === 'semua') {
          return self.posts;
        } else {
          return self.posts.filter(function(data) {
            return self.select === data.web_product_specialf;
          });
        }
      }
    },
    created () {
        this.List()
    },
    methods: {
      List () {
        let limits = '6'
        if (this.$route.name === 'produk') {
          limits = ''
        }
        this.loading  = true
        let formdata = {
              web_product_actived: 'Y',
              limit: limits,
              order_by: 'web_product_sort',
              order_type: 'ASC',
        }
        let param      = this.$functions.ParamPOST(formdata)
        this.$axios.post(this.$functions.UrlPOST('apiWebProductList'),param,{
        headers: {
            'Content-Type': 'text/plain; charset=ISO-8859-1'
        }
        })
        .then(response => {
            let data = response.data
            if (data.length > 0) {
              if (data[0].feedback === 'Y') {
                this.posts = data
              } else {
                this.snackbar.value = true
                this.snackbar.text  = data[0].feedback
              }
            } else {
              this.posts = []
            }
            this.loading  = false
        })
        .catch(e => {
            this.snackbar.value = true
            this.snackbar.text  = e
            this.loading  = false
        })
      },
      Detail (url,specialf) {
        if (specialf === 'Y') {
          this.$router.push({name: 'produk-detail', params: { url: url }})
        } else {
          this.$router.push({name: 'produk-detail-cob', params: { url: url }})
        }
      },
      GoTo () {
        this.$router.push({name: 'produk'})
      }
    }
  }
</script>

<style scoped>
.product-card-title {
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: break-word;
  line-height: 1.3;
  font-size: clamp(0.95rem, 1vw + 0.6rem, 1.1rem);
}
</style>
